import React from "react";
import Box from "@mui/material/Box";
import PageTitle from "../../../../shared/ui/PageTitle";
import BoxContent from "../../../../shared/ui/BoxContent";
import GenericButton from "../../../../shared/ui/GenericButton";
import {useNavigate} from "react-router-dom";
import ReportsList from "../../shared/ReportsList";

const SchoolReports = () => {
    const navigate = useNavigate();

    return (
        <Box component="main">
            <PageTitle
                actions={
                    <GenericButton
                        type="report-generate"
                        onClick={() => {
                            navigate("/rapoarte-scoala/genereaza", {
                                state: {
                                    type: "school",
                                    classroom_id: null,
                                }
                            });
                        }}
                    />
            }>
              Rapoarte școlare
            </PageTitle>
            <BoxContent>
                <Box width="100%">
                    <ReportsList type="school" classroomId="" />
                </Box>
            </BoxContent>

        </Box>
    );
};

export default SchoolReports;
